'use client'

import { useEffect } from 'react'
import { useStytchB2BSession } from '@/packages/auth/hooks/useStytchB2BSession'
import { clearVisitDrafts } from '../../util/visits/draft-cache'

export default function VisitDraftSessionCleanup() {
  const { session, isInitialized } = useStytchB2BSession()
  useEffect(() => {
    if (!isInitialized) return
    const clear = () => {
      try {
        clearVisitDrafts(window.localStorage)
      } catch {}
      try {
        clearVisitDrafts(window.sessionStorage)
      } catch {}
    }
    if (!session) {
      clear()
      return
    }
    const timer = setTimeout(
      clear,
      Math.max(0, Date.parse(session.expires_at) - Date.now())
    )
    return () => clearTimeout(timer)
  }, [session, isInitialized])
  return null
}
